import { useEffect, useRef, useState } from 'react';

export default function RunnerGame() {
  const canvasRef = useRef(null);
  const screenRef = useRef(null);
  const gameStateRef = useRef(false);
  const [started, setStarted] = useState(false);

  const startGame = () => {
    if (gameStateRef.current) return;
    gameStateRef.current = true;
    setStarted(true);

    const canvas = canvasRef.current;
    const screen = screenRef.current;
    canvas.width = screen.offsetWidth;
    canvas.height = screen.offsetHeight;
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;

    let player = { x: W * 0.15, y: H * 0.7, w: 30, h: 36, vy: 0, grounded: true };
    let obstacles = [], score = 0, speed = 3.5, frame = 0, alive = true;
    const GND = H * 0.75;
    let rafId;

    const jump = () => {
      if (player.grounded && alive) { player.vy = -12; player.grounded = false; }
    };

    const onKey = (e) => { if (e.code === 'Space') { e.preventDefault(); jump(); } };
    document.addEventListener('keydown', onKey);
    canvas.addEventListener('touchstart', (e) => { e.preventDefault(); jump(); }, { passive: false });

    function spawnObs() {
      obstacles.push({ x: W, y: GND - 30 - Math.random() * 20, w: 18, h: 30 + Math.random() * 20 });
    }

    function draw() {
      if (!alive) {
        cancelAnimationFrame(rafId);
        ctx.fillStyle = 'rgba(0,0,0,0.7)'; ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = '#F5A623';
        ctx.font = `bold ${W * 0.06}px Cairo, sans-serif`;
        ctx.textAlign = 'center';
        ctx.fillText('انتهت اللعبة!', W / 2, H * 0.42);
        ctx.fillStyle = '#fff';
        ctx.font = `bold ${W * 0.045}px Cairo, sans-serif`;
        ctx.fillText('نقاطك: ' + Math.floor(score / 10), W / 2, H * 0.55);
        ctx.fillStyle = '#F5A623';
        ctx.font = `bold ${W * 0.035}px Cairo, sans-serif`;
        ctx.fillText('اضغط للعب تاني', W / 2, H * 0.67);
        document.removeEventListener('keydown', onKey);

        const restart = () => {
          canvas.removeEventListener('click', restart);
          gameStateRef.current = false;
          setStarted(false);
        };
        canvas.addEventListener('click', restart);
        return;
      }

      const sky = ctx.createLinearGradient(0, 0, 0, H);
      sky.addColorStop(0, '#0e1830'); sky.addColorStop(1, '#1a2850');
      ctx.fillStyle = sky; ctx.fillRect(0, 0, W, H);

      ctx.fillStyle = 'rgba(255,255,255,0.5)';
      for (let i = 0; i < 15; i++) ctx.fillRect((i * 73 + frame * 0.2) % W, (i * 37) % GND, 1.5, 1.5);

      ctx.fillStyle = '#F5A623'; ctx.fillRect(0, GND + player.h, W, 4);
      ctx.fillStyle = '#0e1420'; ctx.fillRect(0, GND + player.h + 4, W, H);

      player.vy += 0.7; player.y += player.vy;
      if (player.y >= GND) { player.y = GND; player.vy = 0; player.grounded = true; }

      ctx.fillStyle = '#F5A623';
      ctx.beginPath(); ctx.roundRect(player.x, player.y, player.w, player.h, 6); ctx.fill();
      ctx.font = `${player.w * 0.8}px serif`;
      ctx.textAlign = 'center';
      ctx.fillText('🏃', player.x + player.w / 2, player.y + player.h * 0.85);

      if (frame % Math.max(55, 80 - score * 2) === 0) spawnObs();
      obstacles.forEach((o) => {
        o.x -= speed;
        ctx.fillStyle = '#e63946';
        ctx.beginPath(); ctx.roundRect(o.x, o.y, o.w, o.h, 4); ctx.fill();
        ctx.font = `${o.w}px serif`;
        ctx.fillText('🌵', o.x + o.w / 2, o.y + o.h * 0.9);
        if (o.x < player.x + player.w - 4 && o.x + o.w > player.x + 4 && o.y < player.y + player.h - 4 && o.y + o.h > player.y + 4) alive = false;
      });
      obstacles = obstacles.filter(o => o.x > -60);

      score++; speed = 3.5 + score / 300;
      ctx.fillStyle = '#F5A623';
      ctx.font = `bold ${W * 0.05}px Cairo, sans-serif`;
      ctx.textAlign = 'right';
      ctx.fillText('نقاط: ' + Math.floor(score / 10), W - 16, 30);

      if (frame < 80 && player.grounded) {
        ctx.fillStyle = 'rgba(255,255,255,0.6)';
        ctx.font = `bold ${W * 0.035}px Cairo, sans-serif`;
        ctx.textAlign = 'center';
        ctx.fillText('اضغط للقفز ⬆', W / 2, H * 0.3);
      }

      frame++;
      rafId = requestAnimationFrame(draw);
    }

    canvas.onclick = jump;
    draw();
  };

  return (
    <div className="demo-screen" ref={screenRef} onClick={!started ? startGame : undefined}>
      <div className="demo-canvas">
        <canvas ref={canvasRef} />
      </div>
      {!started && (
        <div className="play-overlay">
          <div className="play-btn-big">▶</div>
          <div className="play-hint">اضغط للعب</div>
        </div>
      )}
    </div>
  );
}
